import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import LanguageDetector from "i18next-browser-languagedetector";

import fr from "./locales/fr.json";
import en from "./locales/en.json";
import es from "./locales/es.json";
import pt from "./locales/pt.json";
import de from "./locales/de.json";
import ar from "./locales/ar.json";
import it from "./locales/it.json";
import tr from "./locales/tr.json";
import zh from "./locales/zh.json";
import ru from "./locales/ru.json";

const resources = {
  fr: { translation: fr },
  en: { translation: en },
  es: { translation: es },
  pt: { translation: pt },
  de: { translation: de },
  ar: { translation: ar },
  it: { translation: it },
  tr: { translation: tr },
  zh: { translation: zh },
  ru: { translation: ru },
};

// Map full locale codes to i18n language keys
export const localeToLang: Record<string, string> = {
  "fr-FR": "fr", "en-US": "en", "en-GB": "en",
  "es-ES": "es", "pt-BR": "pt", "pt-PT": "pt",
  "de-DE": "de", "it-IT": "it", "ar-SA": "ar",
  "tr-TR": "tr", "zh-CN": "zh", "zh-TW": "zh",
  "ru-RU": "ru",
};

export const langToLocale: Record<string, string> = {
  fr: "fr-FR", en: "en-US", es: "es-ES", pt: "pt-BR",
  de: "de-DE", it: "it-IT", ar: "ar-SA", tr: "tr-TR",
  zh: "zh-CN", ru: "ru-RU",
};

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources,
    fallbackLng: "fr",
    interpolation: { escapeValue: false },
    detection: {
      order: ["localStorage", "navigator"],
      lookupLocalStorage: "kelas-i18n-lang",
      caches: ["localStorage"],
    },
  });

export default i18n;

// Kick off IP-based geolocation detection (only when user has no saved preference).
// Runs async; non-blocking. Falls back silently on any failure.
if (typeof window !== "undefined") {
  import("./geoDetect").then(({ autoDetectLanguageFromGeo }) => {
    autoDetectLanguageFromGeo().catch(() => {});
  });
}
